import { FetchUtil } from "../util/FetchUtil";
import { IArticleLoadRequest } from "../models/IArticleLoadRequest";
import { IArticleLoadResponse } from "../models/IArticleLoadResponse";
import { IArticleServiceEndpoint } from "../models/IArticleServiceEndpoint";
import { StringUtil } from "../util/StringUtil";

export class ArticleService {
  constructor(private readonly _endpoint: IArticleServiceEndpoint) {
  }

  public async load(req: IArticleLoadRequest): Promise<IArticleLoadResponse> {
    const endpoint = this._endpoint.load;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint.");
    }

    const pageNumber =
      req && req.page && req.page > 1 ? req.page.toString() : "";

    const page = pageNumber || "1";

    const topicList = (req.topics || [])
      .map(t => "topicIds=" + encodeURIComponent(t))
      .join("&");

    const queryString = req ? [
      pageNumber ? "page=" + encodeURIComponent(pageNumber) : null,
      req.specialty ? "specialtyId=" + encodeURIComponent(req.specialty) : null,
      topicList
    ].filter(Boolean).join("&") : null;

    const query = queryString ? "?" + queryString : null;

    const url =
      (StringUtil.supplant(endpoint.url, { page, query }) || "")
      .replace(/\{(?:query|page)\}/g, "");

    const result = await FetchUtil
      .sendMessage({ method: endpoint.method, url }, null);

    const response = result as IArticleLoadResponse;
    response.requestId = req.requestId;

    return response;
  }

  public async getSchemaDotOrg(): Promise<string> {
    const endpoint = this._endpoint.schemaDotOrg;
    if (!endpoint) {
      console.error("Could not resolve endpoint for SchemaDotOrg.");

      return "";
    }

    const pageContext = window.Context;
    if (!pageContext || !pageContext.documentid) {
      console.error("Page Context hasn't been loaded unable to load SchemaDotOrg");

      return "";
    }
    const modifiedDate = document?.querySelector<HTMLMetaElement>('meta[name="ModifiedDate"]')?.content ?? "";
    const queryString = pageContext?.documentid ? [
      "pageId=" + encodeURIComponent(pageContext.documentid),
      "modifiedDate="+ encodeURIComponent(modifiedDate)
    ].filter(Boolean).join("&") : null;

    const query = queryString ? "?" + queryString : null;

    const url =
      (StringUtil.supplant(endpoint.url, { query }) || "")
      .replace(/\{(?:query)\}/g, "");

    let response = "";
    try {
      const result = await FetchUtil
      .sendMessage({ method: endpoint.method, url }, null);
      response = result as string;
    } catch {
      console.log("Error in getting schemadotorg");
    }

    return response;

  }
}
